<div class="dialog-container p-t-15 p-b-20 wd-100 h-100">
  <!-- Header Section -->
  <div class="header flex flex-column justify-content-between payment-details-border p-b-12 p-r-20 p-l-20">
    <div class="text-container ">
      <div class="fs-28 fw-700 m-b-5">
        {{ 'PAYMENT_HISTORY.PAYMENT_DETAILS' | fallbackTranslate }}
      </div>
      <div class="fs-16 fw-400 light-black">
        {{ 'PAYMENT_HISTORY.PAYMENT_HISTORY_TITLE' | fallbackTranslate }}
      </div>
    </div>
    <div class=" dialog-header-cross flex-center m-t-10" (click)="closeDialog()">
      <img [src]="images?.CROSS" class="img-20 " alt="close-icon" />
    </div>
  </div>

  <!-- Payments Table -->
  <nz-table class="m-t-15 p-l-20 p-r-20" nzPaginationPosition="none" nzSize="default" [nzData]="payments">
    <thead>
      <tr >
        <th class="fs-16" nzAlign = "center" nzWidth="10%">{{ 'PAYMENT_HISTORY.AMOUNT' | fallbackTranslate }}</th>
        <th class="fs-16" nzAlign="center" nzWidth="20%">{{ 'PAYMENT_HISTORY.PAYMENT_METHODS' | fallbackTranslate }}</th>
        <th class=" fs-16" nzAlign="center" nzWidth="10%">{{ 'PAYMENT_HISTORY.TIME' | fallbackTranslate }}</th>
        <th class="fs-16" nzAlign="center" nzWidth="10%">{{ 'PAYMENT_HISTORY.STATUS' | fallbackTranslate }}</th>
        <th class=" fs-16" nzAlign="center" nzWidth="25%">{{ 'PAYMENT_HISTORY.REASON' | fallbackTranslate }}</th>
      </tr>
    </thead>
    <tbody class="clr-333">
      <tr *ngFor="let payment of payments; trackBy: trackByPaymentId">
        <td nzWidth="10%" nzAlign="center">{{ currency }} {{ payment?.amount }}</td>
        <td nzWidth="20%" nzAlign="center">{{ payment?.payment_method }}</td>
        <td nzWidth="10%" nzAlign="center">{{ payment?.epoch | timezone:'hh:mm A' }}</td>
        <td
          nzWidth="10%"
          nzAlign="center"
          [ngClass]="payment?.status === 2 ? ' fw-600 payment-status-failed' : ' fw-600 payment-status-success'"
        >
          {{ (payment.status === 2 ? 'PAYMENT_HISTORY.FAILED' : 'PAYMENT_HISTORY.SUCCESSFUL' ) | fallbackTranslate }}
        </td>
        <td nzWidth="25%" nzAlign="center">
          {{ payment.status === 2 ? (payment?.error_desc || ('PAYMENT_HISTORY.DEFAULT_FAILED_MSG' | fallbackTranslate)) : '' }}
        </td>
        
      </tr>
    </tbody>
  </nz-table>

  <!-- Payment Failure Information -->
  <div *ngIf="failedPaymentsCount > 0" class="payment-failed-box-info m-t-15 m-r-20 m-l-20 flex flex-column p-t-8 p-b-8">
    <div class="alert-failed">
      <img [src]="images?.ALERT_FAILED" class="img-24 m-t-8 m-l-10 " alt="alert-icon" />
    </div>
    <div class="payment-failure-container m-l-15">
      <div *ngFor="let messageKey of paymentFailureMessages; let i = index; trackBy: trackByPaymentId">
        {{ i + 1 }}. {{ messageKey | fallbackTranslate }}
    </div>
    </div>
  </div>

  <!-- Confirmation Button -->
   <div class="btn-container p-l-20 p-r-20 wd-100">
  <button class="got-it-btn c-pointer wd-100 m-t-16 p-12 color-white" (click)="closeDialog()">
    {{ 'PAYMENT_HISTORY.OKAY_GOT' | fallbackTranslate }}
  </button>
  </div>
</div>
